import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import { ExperimentalFeaturesService } from '../../services/experimental-features.service';

@Injectable({
    providedIn: 'root',
})
export class ExperimentalFeaturesGuard implements CanLoad {
    constructor(
        private authService: AuthenticationService,
        private experimentalFeaturesService: ExperimentalFeaturesService,
    ) {}

    canLoad(): boolean {
        return this.isAuthOkAndAreExperimentalFeaturesEnabled();
    }

    private isAuthOkAndAreExperimentalFeaturesEnabled(): boolean {
        return this.authService.hasValidAccessToken() && this.experimentalFeaturesService.areExperimentalFeaturesEnabled;
    }
}
